import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const contractsAgreementTypesAdapter = getAdapter({ idFieldName: 'value' });

const contractsAgreementTypesSlice = createSlice({
  name: 'contractsAgreementTypes',
  initialState: contractsAgreementTypesAdapter.getInitialState(),
  reducers: {
    setContractsAgreementTypes: (state, { payload: { contractsAgreementTypes } }) => {
      contractsAgreementTypesAdapter.setAll(state, contractsAgreementTypes);
    }
  }
});

const selectors = contractsAgreementTypesAdapter.getSelectors(({ contractsAgreementTypes }) => contractsAgreementTypes);

export const getContractsAgreementTypes = state => selectors.selectAll(state);

export const { setContractsAgreementTypes } = contractsAgreementTypesSlice.actions;

export default contractsAgreementTypesSlice.reducer;
